export default __webpack_public_path__ + "img/9b9035f454a82b1ae3bd7045687eb014.svg";